import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { CheckoutProvider } from "@/contexts/CheckoutContext";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import ProdukterPage from "./pages/ProdukterPage";
import TjansterPage from "./pages/TjansterPage";
import OmOssPage from "./pages/OmOssPage";
import PricingPage from "./pages/PricingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";

import ContactPage from "./pages/ContactPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import AccountPage from "./pages/AccountPage";
import OrderReturnPage from "./pages/OrderReturnPage";
import OrderCancelledPage from "./pages/OrderCancelledPage";
import CookieBanner from "./components/CookieBanner";
import PaymentTestModeBanner from "./components/PaymentTestModeBanner";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/admin/AdminRoute";
import AdminDashboardPage from "./pages/admin/AdminDashboardPage";
import AdminCustomersPage from "./pages/admin/AdminCustomersPage";
import AdminCustomerDetailPage from "./pages/admin/AdminCustomerDetailPage";
import AdminSubscriptionsPage from "./pages/admin/AdminSubscriptionsPage";
import AdminDeliveriesPage from "./pages/admin/AdminDeliveriesPage";
import AdminInvoicesPage from "./pages/admin/AdminInvoicesPage";
import AdminDiscountsPage from "./pages/admin/AdminDiscountsPage";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <CheckoutProvider>
          <PaymentTestModeBanner />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/produkter" element={<ProdukterPage />} />
            <Route path="/tjanster" element={<TjansterPage />} />
            <Route path="/om-oss" element={<OmOssPage />} />
            <Route path="/pricing" element={<ProtectedRoute><PricingPage /></ProtectedRoute>} />
            <Route path="/login" element={<LoginPage />} />
           <Route path="/register" element={<RegisterPage />} />
           <Route path="/reset-password" element={<ResetPasswordPage />} />

            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/account" element={<AccountPage />} />
            <Route path="/order/return" element={<OrderReturnPage />} />
            <Route path="/order/cancelled" element={<OrderCancelledPage />} />
            <Route path="/admin" element={<AdminRoute><AdminDashboardPage /></AdminRoute>} />
            <Route path="/admin/customers" element={<AdminRoute><AdminCustomersPage /></AdminRoute>} />
            <Route path="/admin/customers/:id" element={<AdminRoute><AdminCustomerDetailPage /></AdminRoute>} />
            <Route path="/admin/subscriptions" element={<AdminRoute><AdminSubscriptionsPage /></AdminRoute>} />
            <Route path="/admin/deliveries" element={<AdminRoute><AdminDeliveriesPage /></AdminRoute>} />
            <Route path="/admin/invoices" element={<AdminRoute><AdminInvoicesPage /></AdminRoute>} />
            <Route path="/admin/discounts" element={<AdminRoute><AdminDiscountsPage /></AdminRoute>} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <CookieBanner />
        </CheckoutProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
